import { Box } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { widgetItemStyle, widgetItemCountStyle, widgetItemTitleStyle } from 'basics/styles/widget.style';
import useCountTacticsWidget from 'components/CountWidgets/CountTacticsWidget/CountTacticsWidget.hook';
import { CountWidgetPropsType } from 'components/CountWidgets/CountWidget.types';
import Loader from 'yoda-ui/components/Loader';
import { YodaColors } from 'yoda-ui/yodaTheme';

const CountTacticsWidget: FC<CountWidgetPropsType> = ({
  filters,
  useAdminFilters,
}) => {
  const { value, loading } = useCountTacticsWidget(filters, useAdminFilters);
  const { t } = useTranslation();

  return (
    <Box sx={ widgetItemStyle } >
      <Box sx={ widgetItemTitleStyle }>
        <img src='/dashboard/tactics-icon.svg' alt="Tactics-icon" style={ { height: 'inherit' } } />
        { t('maya_count_tactics_widget_label') }
      </Box>
      <Box sx={ widgetItemCountStyle } visibility={ loading ? 'hidden' : 'inherit' }>
        { value !== undefined ? value as number : '-' }
      </Box>
      { loading ? <Loader center size={ 1 } color={ YodaColors.inherit } /> : null }
    </Box>
  );
};

export default CountTacticsWidget;
